import React, { useState, useEffect, useRef } from "react";
import {
  TextFieldElement,
  NumberFieldElement,
  EmailFieldElement,
  PhoneNumberFieldElement,
  DropdownSelectElement,
  BooleanOperatorElement,
  TextAreaElement,
  HashMapElement,
  DynamicListElement,
  EmptyPlaceholderElement,
  FormDefinitionStep,
  SubmitButtonDefinition
} from "./FormSharedInterfaces";

const NumberFieldElementComponent = ({ elementDetails }: { elementDetails: NumberFieldElement }) => {
  const [inputValue, setInputValue] = useState(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");

  useEffect(() => {
    setInputValue(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");
    console.log("inside useEffect ", elementDetails.elementCurrentValue);
  }, [elementDetails.elementCurrentValue, elementDetails.elementDefaultValue]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only allow numeric input (can include decimal point)
    const numericValue = e.target.value.replace(/[^0-9.]/g, "");

    // Ensure only one decimal point
    const parts = numericValue.split(".");
    const sanitizedValue = parts.length > 1 ? `${parts[0]}.${parts.slice(1).join("")}` : numericValue;

    // Call the handler with the sanitized value
    if (elementDetails.elementOnChangeHandler) {
      console.log("sanitizedValue current ", sanitizedValue);
      // Create a synthetic event with the sanitized value
      const syntheticEvent = {
        ...e,
        target: { ...e.target, value: sanitizedValue },
      };
      elementDetails.elementOnChangeHandler(syntheticEvent);
      setInputValue(sanitizedValue);

      console.log(" elementDetails.elementCurrentValue ", elementDetails.elementCurrentValue);
    }
  };

  return (
    <div className="modal-input-group">
      <div className="modal-subtitle-mobile">{elementDetails.elementHeaderMessage}</div>
      <input
        type="text" // Using "text" to have custom validation
        placeholder={elementDetails.elementPlaceHolderMessage}
        name={elementDetails.elementUniqueName}
        value={inputValue}
        onChange={handleInputChange}
        className="modal-input-mobile"
        disabled={elementDetails.elementIsDisabledHandler ? elementDetails.elementIsDisabledHandler() : false}
      />
    </div>
  );
};

const TextFieldElementComponent = ({ elementDetails }: { elementDetails: TextFieldElement }) => {
  const [inputValue, setInputValue] = useState(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");
  console.log("elementDetails ", elementDetails.elementUniqueName)
  useEffect(() => {
    setInputValue(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");
    console.log("TextFieldElementComponent inside useEffect ", elementDetails.elementCurrentValue);
  }, [elementDetails.elementCurrentValue, elementDetails.elementDefaultValue]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // Apply max length constraint if specified
    const constrainedValue = elementDetails.maxLength ? value.slice(0, elementDetails.maxLength) : value;

    // Call the handler with the constrained value
    if (elementDetails.elementOnChangeHandler) {
      const syntheticEvent = {
        ...e,
        name: elementDetails.elementUniqueName,
        target: { ...e.target, value: constrainedValue },
      };
      elementDetails.elementOnChangeHandler(syntheticEvent);
      setInputValue(constrainedValue);
    }
  };

  return (
    <div className="modal-input-group">
        <div className="modal-subtitle-mobile">{elementDetails.elementHeaderMessage}</div>
        <input
            placeholder={elementDetails.elementPlaceHolderMessage}
            name={elementDetails.elementUniqueName}
            value={inputValue}
            onChange={(e) => {
                handleInputChange(e as unknown as React.ChangeEvent<HTMLInputElement>);
                // Auto-resize
                e.target.style.height = 'auto';
                e.target.style.height = `${e.target.scrollHeight}px`;
            }}
            className="modal-input-mobile"
            style={{
                ...elementDetails.customStyle, // Apply custom styles if present
                resize: 'none',
                overflow: 'hidden',
                minHeight: '40px', // Set appropriate initial height
                height: 'auto',
                ...(elementDetails.customStyle ? {} : { resize: 'none', overflow: 'hidden' }) // Override logic if customStyle is present
            }}
            minLength={elementDetails.minLength}
            maxLength={elementDetails.maxLength}
            disabled={elementDetails.elementIsDisabledHandler ? elementDetails.elementIsDisabledHandler() : false}
        />
    </div>
  );
};

const EmailFieldElementComponent = ({ elementDetails }: { elementDetails: EmailFieldElement }) => {
  const [inputValue, setInputValue] = useState(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");
  const [error, setError] = useState("");

  useEffect(() => {
    setInputValue(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");
    // console.log("EmailFieldElementComponent inside useEffect ", elementDetails.elementCurrentValue);
  }, [elementDetails.elementCurrentValue, elementDetails.elementDefaultValue]);

  const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);


  useEffect(() => {
    handleError()
}, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    handleError()
    // // Clear error when typing
    // if (error) setError("");

    if (elementDetails.elementOnChangeHandler) {
      elementDetails.elementOnChangeHandler(e);
    }
  };

  const handleError = () =>{
    if (inputValue && !isValidEmail(inputValue)) {
        setError("Please enter a valid email address");
        elementDetails.updateFieldValidity(elementDetails.elementUniqueName, false)

    }else {
        elementDetails.updateFieldValidity(elementDetails.elementUniqueName, true)
        setError("");
    };
  }

  const handleBlur = () => {
    handleError()
  };

  return (
    <div className="modal-input-group">
      <div className="modal-subtitle-mobile">{elementDetails.elementHeaderMessage}</div>
      <input
        type="email"
        placeholder={elementDetails.elementPlaceHolderMessage}
        name={elementDetails.elementUniqueName}
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        className={`modal-input-mobile ${error ? "error" : ""}`}
        disabled={elementDetails.elementIsDisabledHandler ? elementDetails.elementIsDisabledHandler() : false}
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

const FormSubmitButtonComponent = ({ submitButtonDefinition }: { submitButtonDefinition: SubmitButtonDefinition }) => {
  return (
    <button
      id="modal-navigation-next"
      className="modal-navigation-button"
      type="button"
      onClick={() => {
        console.log();
        submitButtonDefinition.nextStep();
      }}
    >
      {submitButtonDefinition.currentStepValue == submitButtonDefinition.finalStepCount ? "Submit" : "Next"}
    </button>
  );
};

const FormBackButtonComponent = ({ submitButtonDefinition }: { submitButtonDefinition: SubmitButtonDefinition }) => {
  // Only render the back button if we're not on the first step
  if (submitButtonDefinition.currentStepValue && submitButtonDefinition.currentStepValue <= 1) {
    return <div></div>;
  }

  return (
    <button
      id="modal-navigation-back"
      className="modal-navigation-button modal-back-button"
      type="button"
      onClick={() => {
        if (submitButtonDefinition.prevStep) {
          submitButtonDefinition.prevStep();
        }
      }}
    >
      Back
    </button>
  );
};

const FormCancelButtonComponent = ({ submitButtonDefinition }: { submitButtonDefinition: SubmitButtonDefinition }) => {
  // Only render the cancel button if a cancel handler is provided
  if (!submitButtonDefinition || !submitButtonDefinition.handleCancelHandler) {
    return <div></div>;
  }

  return (
    <button
      id="modal-navigation-cancel"
      className="modal-navigation-button modal-cancel-button"
      type="button"
      onClick={() => {
        if (submitButtonDefinition && submitButtonDefinition.handleCancelHandler) {
          submitButtonDefinition.handleCancelHandler();
        }
      }}
    >
      Cancel
    </button>
  );
};

// Custom hook to track form validation state
const useFormValidation = (step: FormDefinitionStep) => {
    const [validFields, setValidFields] = useState<Record<string, boolean>>({});
    const [isStepValid, setIsStepValid] = useState(false);
    

    // Initialize validation state for all fields in the step
    useEffect(() => {
        if (!step) return;
        
        const initialValidation: Record<string, boolean> = {};
        step.formStepContents.forEach(element => {
            // A field is initially valid if it's not mandatory or if it already has a value
            initialValidation[element.elementUniqueName] = 
                !element.mandatory || Boolean(element.elementCurrentValue);
        });
        setValidFields(initialValidation);
    }, [step]);

    // Check if all mandatory fields are valid whenever validFields changes
    useEffect(() => {
        if (!step) return;
        
        const allMandatoryFieldsValid = step.formStepContents.every(element => 
            !element.mandatory || validFields[element.elementUniqueName]
        );
        setIsStepValid(allMandatoryFieldsValid);
    }, [validFields, step]);

    // Function to update validation state for a specific field
    const updateFieldValidity = (fieldName: string, isValid: boolean) => {
        setValidFields(prev => ({
            ...prev,
            [fieldName]: isValid
        }));
    };

    return { isStepValid, updateFieldValidity };
};

// Enhanced FormSubmitButtonComponent with validation check
const EnhancedFormSubmitButtonComponent = ({ 
    submitButtonDefinition, 
    isStepValid 
}: { 
    submitButtonDefinition: SubmitButtonDefinition,
    isStepValid: boolean 
}) => {
    return (
        <button
            id="modal-navigation-next"
            className="modal-navigation-button"
            type="button"
            onClick={() => {
                if (isStepValid) {
                    if (submitButtonDefinition.currentStepValue === submitButtonDefinition.finalStepCount && submitButtonDefinition.handleSubmitHandler) {
                        submitButtonDefinition.handleSubmitHandler();
                    } else if (submitButtonDefinition.nextStep) {
                        submitButtonDefinition.nextStep();
                    }
                }
            }}
            disabled={!isStepValid}
            style={{ opacity: isStepValid ? 1 : 0.6, ...submitButtonDefinition.customStyle }}
        >
            {submitButtonDefinition.currentStepValue === submitButtonDefinition.finalStepCount ? "Submit" : "Next"}
        </button>
    );
};


const DropdownSelectElementComponent = ({ elementDetails }: { elementDetails: DropdownSelectElement }) => {
    const [selectedValue, setSelectedValue] = useState(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");

    useEffect(() => {
        setSelectedValue(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");
    }, [elementDetails.elementCurrentValue, elementDetails.elementDefaultValue]);

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        setSelectedValue(value);

        if (elementDetails.elementOnChangeHandler) {
            // Create a synthetic event with the correct target type
            const syntheticEvent = {
                ...e,
                target: { ...e.target, value },
            } as unknown as React.ChangeEvent<HTMLInputElement>;
            
            elementDetails.elementOnChangeHandler(syntheticEvent);
            
            // Update field validity if the function exists
            if (elementDetails.updateFieldValidity) {
                elementDetails.updateFieldValidity(
                    elementDetails.elementUniqueName, 
                    // Field is valid if it's not empty or not mandatory
                    value !== "" || !elementDetails.mandatory
                );
            }
        }
    };

    return (
        <div className="modal-input-group">
            <div className="modal-subtitle-mobile">{elementDetails.elementHeaderMessage}</div>
            <select
                name={elementDetails.elementUniqueName}
                value={selectedValue}
                onChange={handleSelectChange}
                className="modal-input-mobile"
                disabled={elementDetails.elementIsDisabledHandler ? elementDetails.elementIsDisabledHandler() : false}
            >
                <option value="">{elementDetails.elementPlaceHolderMessage || "Select an option"}</option>
                {elementDetails.options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

const BooleanOperatorElementComponent = ({ elementDetails }: { elementDetails: BooleanOperatorElement }) => {
    const [checked, setChecked] = useState(
        elementDetails.elementCurrentValue !== undefined 
            ? elementDetails.elementCurrentValue 
            : elementDetails.elementDefaultValue || false
    );

    useEffect(() => {
        setChecked(
            elementDetails.elementCurrentValue !== undefined 
                ? elementDetails.elementCurrentValue 
                : elementDetails.elementDefaultValue || false
        );
    }, [elementDetails.elementCurrentValue, elementDetails.elementDefaultValue]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.checked;
        setChecked(value);

        if (elementDetails.elementOnChangeHandler) {
            // Create a synthetic event with the correct value
            const syntheticEvent = {
                ...e,
                target: { ...e.target, value: value.toString() },
            };
            elementDetails.elementOnChangeHandler(syntheticEvent);
            
            // Update field validity if the function exists
            if (elementDetails.updateFieldValidity) {
                elementDetails.updateFieldValidity(
                    elementDetails.elementUniqueName, 
                    true // Boolean fields are always valid
                );
            }
        }
    };

    return (
        <div className="modal-input-group">
            <label className="checkbox-container">
                <input
                    type="checkbox"
                    name={elementDetails.elementUniqueName}
                    checked={checked}
                    onChange={handleInputChange}
                    disabled={elementDetails.elementIsDisabledHandler ? elementDetails.elementIsDisabledHandler() : false}
                />
                <span className="modal-subtitle-mobile">{elementDetails.elementHeaderMessage}</span>
            </label>
            {elementDetails.placeholder && <div className="helper-text">{elementDetails.placeholder}</div>}
        </div>
    );
};

const PhoneNumberFieldElementComponent = ({ elementDetails }: { elementDetails: PhoneNumberFieldElement }) => {
  const [inputValue, setInputValue] = useState(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");
  const [error, setError] = useState("");

  useEffect(() => {
    setInputValue(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");
  }, [elementDetails.elementCurrentValue, elementDetails.elementDefaultValue]);

  const isValidPhoneNumber = (phone: string) => {
    // Basic phone number validation - allows for international formats
    // This regex pattern allows:
    // - Optional + at start
    // - Numbers, spaces, hyphens, and parentheses
    // - At least 10 digits total
    const phoneRegex = /^\+?[\d\s\-\(\)]{10,}$/;
    return phoneRegex.test(phone);
  };

  useEffect(() => {
    handleError();
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    handleError();

    if (elementDetails.elementOnChangeHandler) {
      elementDetails.elementOnChangeHandler(e);
    }
  };

  const handleError = () => {
    if (inputValue && !isValidPhoneNumber(inputValue)) {
      setError("Please enter a valid phone number");
      if (elementDetails.updateFieldValidity) {
        elementDetails.updateFieldValidity(elementDetails.elementUniqueName, false);
      }
    } else {
      if (elementDetails.updateFieldValidity) {
        elementDetails.updateFieldValidity(elementDetails.elementUniqueName, true);
      }
      setError("");
    }
  };

  const handleBlur = () => {
    handleError();
  };

  return (
    <div className="modal-input-group">
      <div className="modal-subtitle-mobile">{elementDetails.elementHeaderMessage}</div>
      <input
        type="tel"
        placeholder={elementDetails.elementPlaceHolderMessage}
        name={elementDetails.elementUniqueName}
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        className={`modal-input-mobile ${error ? "error" : ""}`}
        disabled={elementDetails.elementIsDisabledHandler ? elementDetails.elementIsDisabledHandler() : false}
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

const TextAreaElementComponent = ({ elementDetails }: { elementDetails: TextAreaElement }) => {
  const [inputValue, setInputValue] = useState(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    setInputValue(elementDetails.elementCurrentValue || elementDetails.elementDefaultValue || "");
  }, [elementDetails.elementCurrentValue, elementDetails.elementDefaultValue]);

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setInputValue(value);

    if (elementDetails.elementOnChangeHandler) {
      // Create a synthetic event with the correct target type
      const syntheticEvent = {
        ...e,
        target: { ...e.target, value },
      } as unknown as React.ChangeEvent<HTMLInputElement>;
      
      elementDetails.elementOnChangeHandler(syntheticEvent);
      
      // Update field validity if the function exists
      if (elementDetails.updateFieldValidity) {
        elementDetails.updateFieldValidity(
          elementDetails.elementUniqueName, 
          value !== "" || !elementDetails.mandatory
        );
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // Handle Tab key to insert tab character instead of moving focus
    if (e.key === 'Tab') {
      e.preventDefault();
      
      const textarea = textareaRef.current;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const currentValue = inputValue;
      
      // Insert tab character (4 spaces) at cursor position
      const tabCharacter = '    '; // 4 spaces for better visual consistency
      const newValue = currentValue.substring(0, start) + tabCharacter + currentValue.substring(end);
      const newCursorPos = start + tabCharacter.length;
      
      // Update the value
      setInputValue(newValue);
      
      // Update cursor position after DOM update
      requestAnimationFrame(() => {
        if (textarea) {
          textarea.setSelectionRange(newCursorPos, newCursorPos);
          textarea.focus();
        }
      });

      // Trigger onChange handler to update parent state
      if (elementDetails.elementOnChangeHandler) {
        const syntheticEvent = {
          ...e,
          target: { ...textarea, value: newValue },
        } as unknown as React.ChangeEvent<HTMLInputElement>;
        
        elementDetails.elementOnChangeHandler(syntheticEvent);
        
        // Update field validity if the function exists
        if (elementDetails.updateFieldValidity) {
          elementDetails.updateFieldValidity(
            elementDetails.elementUniqueName, 
            newValue !== "" || !elementDetails.mandatory
          );
        }
      }
    }
  };

  return (
    <div className="modal-input-group">
      <div className="modal-subtitle-mobile">{elementDetails.elementHeaderMessage}</div>
      <textarea
        ref={textareaRef}
        placeholder={elementDetails.elementPlaceHolderMessage}
        name={elementDetails.elementUniqueName}
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        className="modal-input-mobile"
        style={elementDetails.customStyle}
        disabled={elementDetails.elementIsDisabledHandler ? elementDetails.elementIsDisabledHandler() : false}
      />
    </div>
  );
};

const HashMapElementComponent = ({ elementDetails }: { elementDetails: HashMapElement }) => {
  const [pairMap, setPairMap] = useState<Record<string, string>>(
    elementDetails.elementCurrentValue || {}
  );
  const [keys, setKeys] = useState<string[]>(Object.keys(elementDetails.elementCurrentValue || {}));

  useEffect(() => {
    setPairMap(elementDetails.elementCurrentValue || {});
    setKeys(Object.keys(elementDetails.elementCurrentValue || {}));
  }, [elementDetails.elementCurrentValue]);

  const handleAddPair = () => {
    if (elementDetails.maxPairs && keys.length >= elementDetails.maxPairs) {
      return;
    }
    
    // Generate a temporary key
    // const tempKey = `key_${Date.now()}`;
    const tempKey = `Default Value`;
    const newKeys = [...keys, tempKey];
    const newPairMap = { ...pairMap, [tempKey]: '' };
    
    setKeys(newKeys);
    setPairMap(newPairMap);
  };

  const handleRemovePair = (keyToRemove: string) => {
    const newKeys = keys.filter(key => key !== keyToRemove);
    const newPairMap = { ...pairMap };
    delete newPairMap[keyToRemove];
    
    setKeys(newKeys);
    setPairMap(newPairMap);
    
    // Update form data
    updateFormData(newPairMap);
  };

  const handleKeyChange = (oldKey: string, newKey: string) => {
    if (oldKey === newKey) return;
    
    const newPairMap = { ...pairMap };
    const value = newPairMap[oldKey];
    
    // Remove old key and add new key with the same value
    delete newPairMap[oldKey];
    newPairMap[newKey] = value;
    
    // Update keys array
    const newKeys = keys.map(k => k === oldKey ? newKey : k);
    
    setKeys(newKeys);
    setPairMap(newPairMap);
    
    // Update form data
    updateFormData(newPairMap);
  };

  const handleValueChange = (key: string, value: string) => {
    const newPairMap = { ...pairMap, [key]: value };
    setPairMap(newPairMap);
    
    // Update form data
    updateFormData(newPairMap);
  };

  const updateFormData = (data: Record<string, string>) => {
    // Create synthetic event to update form data
    const syntheticEvent = {
      target: { value: data },
      currentTarget: { value: data },
      nativeEvent: new Event('change'),
      bubbles: true,
      cancelable: true,
      preventDefault: () => {},
      stopPropagation: () => {},
      isDefaultPrevented: () => false,
      isPropagationStopped: () => false,
      persist: () => {},
      timeStamp: Date.now(),
      type: 'change'
    } as unknown as React.ChangeEvent<HTMLInputElement>;
    
    if (elementDetails.elementOnChangeHandler) {
      elementDetails.elementOnChangeHandler(syntheticEvent);
    }
    
    // Update field validity if available
    if (elementDetails.updateFieldValidity) {
      const isValid = !elementDetails.mandatory || Object.keys(data).length > 0;
      elementDetails.updateFieldValidity(elementDetails.elementUniqueName, isValid);
    }
  };

  return (
    <div className="modal-input-group">
      <div className="modal-subtitle-mobile">{elementDetails.elementHeaderMessage}</div>
      <div className="hash-map-container">
        {keys.map((key, index) => (
          <div key={index} className="hash-map-pair">
            <input
              type="text"
              placeholder={elementDetails.keyPlaceholder || "Key"}
              value={key}
              onChange={(e) => handleKeyChange(key, e.target.value)}
              className="modal-input-mobile"
            />
            <input
              type="text"
              placeholder={elementDetails.valuePlaceholder || "Value"}
              value={pairMap[key] || ''}
              onChange={(e) => handleValueChange(key, e.target.value)}
              className="modal-input-mobile"
            />
            <button
              type="button"              
              onClick={() => handleRemovePair(key)}
              className="modal-navigation-button modal-back-button"
              id="modal-navigation-back"
              aria-label="Remove pair"
            >
              Remove 
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={handleAddPair}
          className="modal-navigation-button"
          disabled={elementDetails.maxPairs && keys.length >= elementDetails.maxPairs}
          id="modal-navigation-next"
        >
          Add
        </button>
      </div>
    </div>
  );
};

const EmptyPlaceholderElementComponent = ({ elementDetails }: { elementDetails: EmptyPlaceholderElement }) => {
  return (
    <div className="modal-input-group" style={elementDetails.customStyle}>
      <div className="modal-subtitle-mobile">{elementDetails.elementHeaderMessage}</div>
    </div>
  );
};

const DynamicListElementComponent = ({ elementDetails }: { elementDetails: DynamicListElement }) => {
  const [listItems, setListItems] = useState<Array<Record<string, any>>>(
    elementDetails.elementCurrentValue || []
  );

  useEffect(() => {
    setListItems(elementDetails.elementCurrentValue || []);
  }, [elementDetails.elementCurrentValue]);

  const handleAddItem = () => {
    if (elementDetails.maxItems && listItems.length >= elementDetails.maxItems) {
      return;
    }

    const newItem: Record<string, any> = {};
    elementDetails.listItemFields.forEach(field => {
      newItem[field.fieldName] = '';
    });

    const newListItems = [...listItems, newItem];
    setListItems(newListItems);
    updateFormData(newListItems);
  };

  const handleRemoveItem = (index: number) => {
    if (elementDetails.minItems && listItems.length <= elementDetails.minItems) {
      return;
    }

    const newListItems = listItems.filter((_, i) => i !== index);
    setListItems(newListItems);
    updateFormData(newListItems);
  };

  const handleFieldChange = (itemIndex: number, fieldName: string, value: any) => {
    const newListItems = [...listItems];
    newListItems[itemIndex] = {
      ...newListItems[itemIndex],
      [fieldName]: value
    };
    setListItems(newListItems);
    updateFormData(newListItems);
  };

  const updateFormData = (data: Array<Record<string, any>>) => {
    if (elementDetails.elementOnChangeHandler) {
      const syntheticEvent = {
        target: { value: data }
      } as unknown as React.ChangeEvent<HTMLInputElement>;
      elementDetails.elementOnChangeHandler(syntheticEvent);
    }
  };

  const renderField = (field: any, itemIndex: number, fieldValue: any) => {
    const fieldProps = {
      value: fieldValue || '',
      onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => 
        handleFieldChange(itemIndex, field.fieldName, e.target.value),
      placeholder: field.fieldPlaceholder || '',
      disabled: elementDetails.elementIsDisabledHandler ? elementDetails.elementIsDisabledHandler() : false,
      className: 'modal-input',
      style: elementDetails.inputFieldStyle
    };

    switch (field.fieldType) {
      case 'text':
      case 'email':
      case 'phone':
        return (
          <input
            type={field.fieldType === 'email' ? 'email' : field.fieldType === 'phone' ? 'tel' : 'text'}
            {...fieldProps}
          />
        );
      case 'number':
        return (
          <input
            type="number"
            {...fieldProps}
            min={field.fieldValidation?.min}
            max={field.fieldValidation?.max}
            step="0.01"
          />
        );
      case 'textarea':
        return (
          <textarea
            {...fieldProps}
            rows={3}
            className="modal-textarea"
          />
        );
      case 'dropdown':
        return (
          <select {...fieldProps}>
            <option value="">Select {field.fieldLabel}</option>
            {field.dropdownOptions?.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );
      case 'boolean':
        return (
          <input
            type="checkbox"
            checked={fieldValue || false}
            onChange={(e) => handleFieldChange(itemIndex, field.fieldName, e.target.checked)}
            disabled={elementDetails.elementIsDisabledHandler ? elementDetails.elementIsDisabledHandler() : false}
          />
        );
      default:
        return <input type="text" {...fieldProps} />;
    }
  };

  return (
    <div className="modal-input-group" style={elementDetails.customStyle}>
      <div className="modal-subtitle-mobile">{elementDetails.elementHeaderMessage}</div>
      {elementDetails.elementPlaceHolderMessage && (
        <div className="modal-subtitle-mobile" style={{ fontSize: '0.9em', color: '#666' }}>
          {elementDetails.elementPlaceHolderMessage}
        </div>
      )}
      
      {listItems.length === 0 && elementDetails.allowEmptyList !== false ? (
        <div className="modal-subtitle-mobile" style={{ color: '#999', fontStyle: 'italic' }}>
          No items added yet
        </div>
      ) : (
        listItems.map((item, itemIndex) => (
          <div key={itemIndex} className="dynamic-list-item" style={{ 
            border: '1px solid #ddd', 
            borderRadius: '8px', 
            padding: '15px', 
            marginBottom: '10px',
            backgroundColor: '#f9f9f9',
            ...elementDetails.listItemStyle
          }}>
            {elementDetails.listItemTitle && (
              <div className="modal-subtitle-mobile" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                {elementDetails.listItemTitle} {itemIndex + 1}
              </div>
            )}
            
            <div className="dynamic-list-fields" style={{ display: 'grid', gap: '10px' }}>
              {elementDetails.listItemFields.map((field, fieldIndex) => (
                <div key={fieldIndex} className="dynamic-list-field" style={elementDetails.fieldContainerStyle}>
                  <label className="modal-subtitle-mobile" style={{ 
                    fontSize: '0.9em', 
                    marginBottom: '5px',
                    ...elementDetails.fieldLabelStyle
                  }}>
                    {field.fieldLabel}
                    {field.fieldValidation?.required && <span style={{ color: 'red' }}> *</span>}
                  </label>
                  {renderField(field, itemIndex, item[field.fieldName])}
                </div>
              ))}
            </div>
            
            <div style={{ marginTop: '10px', textAlign: 'right' }}>
              <button
                type="button"
                onClick={() => handleRemoveItem(itemIndex)}
                className="modal-navigation-button"
                disabled={elementDetails.minItems && listItems.length <= elementDetails.minItems}
                style={{ 
                  backgroundColor: '#dc3545', 
                  color: 'white', 
                  border: 'none',
                  padding: '5px 10px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  ...elementDetails.removeButtonStyle
                }}
              >
                {elementDetails.removeButtonText || 'Remove'}
              </button>
            </div>
          </div>
        ))
      )}
      
      <div style={{ marginTop: '10px' }}>
        <button
          type="button"
          onClick={handleAddItem}
          className="modal-navigation-button"
          disabled={elementDetails.maxItems && listItems.length >= elementDetails.maxItems}
          style={{ 
            backgroundColor: '#007bff', 
            color: 'white', 
            border: 'none',
            padding: '8px 15px',
            borderRadius: '4px',
            cursor: 'pointer',
            ...elementDetails.addButtonStyle
          }}
        >
          {elementDetails.addButtonText || 'Add Item'}
        </button>
      </div>
    </div>
  );
};

export {
  NumberFieldElementComponent,
  TextFieldElementComponent,
  EmailFieldElementComponent,
  FormSubmitButtonComponent,
  FormBackButtonComponent,
  FormCancelButtonComponent,
  EnhancedFormSubmitButtonComponent,
  useFormValidation,
  DropdownSelectElementComponent,
  BooleanOperatorElementComponent,
  PhoneNumberFieldElementComponent,
  TextAreaElementComponent,
  HashMapElementComponent,
  DynamicListElementComponent,
  EmptyPlaceholderElementComponent
};
